export interface Starter { label: string; shown: string; full: string }

export const STARTERS: Starter[] = [
  { label: "ITC", shown: "Can ITC be denied if my supplier didn't pay?", full: "Can ITC be denied because my supplier did not pay the tax?" },
  { label: "Precedent", shown: "Is 2023 INSC 212 still good law?", full: "Is 2023 INSC 212 still good law?" },
  { label: "Section", shown: "What does section 17(5)(d) block?", full: "What does CGST section 17(5)(d) say in plain words?" },
]

/** Three starter questions; picking one types the full question into the composer. */
export function StarterQuestions({ onPick }: { onPick: (question: string) => void }) {
  return (
    <ul className="nl-starters nl-rise" style={{ "--i": 5 } as React.CSSProperties} role="list" data-fade>
      {STARTERS.map((s) => (
        <li key={s.label}>
          <button className="nl-starter nl-cur" type="button" onClick={() => onPick(s.full)}>
            <span className="nl-lab">{s.label}</span>
            <span className="nl-lul">{s.shown.replace(/\)\(/g, ")\u2060(")}</span>
          </button>
        </li>
      ))}
    </ul>
  )
}

/** What the empty composer types out to the reader. Dummy names only. */
export const TYPED_EXAMPLES: readonly string[] = [
  "My supplier didn't file GSTR-1. Can ITC still be denied?",
  "Acme Traders got an SCN under section 74 for FY 2019-20. Is it time-barred?",
  "Is 2023 INSC 212 still good law?",
  "What does section 17(5)(d) block?",
  "Drop a notice and I'll tell you where it's weak.",
]
